// extracted by mini-css-extract-plugin
module.exports = {"ourClients__item":"style_ourClients__item__8AYbv","ourClients__link":"style_ourClients__link__RlWQJ","ourClients__image":"style_ourClients__image__Gg0xp"};